import React from 'react';
import {Stack, Box} from '@mui/material';
import {
  Body,
  Headline,
  Label,
  designSystemToken,
} from '@lightricks/react-design-system';
import styles from './Sidebar.module.scss';

export interface SidebarItem {
  id: string;
  label: string;
  count: number;
}

interface SidebarProps {
  testID?: string;
  title: string;
  items: SidebarItem[];
  selectedId: string;
  onSelect: (id: string) => void;
}

function Sidebar({
  testID = 'sidebar',
  title,
  items,
  selectedId,
  onSelect,
}: SidebarProps) {
  const handleItemClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.currentTarget;
    const itemId = target.getAttribute('data-id');
    if (itemId) {
      onSelect(itemId);
    }
  };

  return (
    <Stack className={styles.container} data-testid={testID}>
      <Label
        size="md"
        className={styles.heading}
        color={designSystemToken('semantic.fg.tertiary')}
      >
        {title}
      </Label>
      <Stack className={styles.itemsContainer}>
        {items.map((item) => {
          const isSelected = selectedId === item.id;
          return (
            <Box
              key={item.id}
              className={`${styles.item} ${isSelected ? styles.selected : ''}`}
              onClick={handleItemClick}
              role="button"
              tabIndex={0}
              data-testid={`${testID}-item-${item.id}`}
              data-id={item.id}
            >
              {isSelected ? (
                <Headline
                  size="xxs"
                  color={designSystemToken('semantic.fg.black')}
                >
                  {item.label}
                </Headline>
              ) : (
                <Body size="md" color={designSystemToken('reference.gray.600')}>
                  {item.label}
                </Body>
              )}
              {isSelected ? (
                <Headline size="xxxs">{item.count}</Headline>
              ) : (
                <Body
                  size="sm"
                  color={designSystemToken('semantic.fg.secondary')}
                >
                  {item.count}
                </Body>
              )}
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
}

export default Sidebar;
